import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { PriorityTask } from '@backrs_ui/grow-ui/src/redux/priorities/priorities.types';

export const useAgentContext = (unassignedTasks: PriorityTask[]) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Unassigned Tasks',
    description: 'Tasks not yet assigned to any playlist',
  });

  useRegisterAgentContext({
    kind: 'list',
    description: 'Tasks not assigned to any playlist',
    data: { unassignedTasks },
  });
};
